module.exports = __webpack_public_path__ + "img/go_back.582610b0.svg";